import { render, staticRenderFns } from "./BlockType3List.vue?vue&type=template&id=ecde7708&scoped=true"
import script from "./BlockType3List.vue?vue&type=script&lang=ts"
export * from "./BlockType3List.vue?vue&type=script&lang=ts"
import style0 from "./BlockType3List.vue?vue&type=style&index=0&id=ecde7708&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../src-custom-solutions/president-election/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecde7708",
  null
  
)

export default component.exports